const Auth = {
  el: {
    loginSection: document.querySelector('#login-section') as HTMLElement | null,
    registerSection: document.querySelector('#register-section') as HTMLElement | null,
  },
  init() {
    if (this.el.loginSection) {
      this.initFormSection(this.el.loginSection)
    }
    if (this.el.registerSection) {
      this.initFormSection(this.el.registerSection)
    }
  },
  initFormSection(section: HTMLElement) {
    const el = {
      root: section,
      navButtons: section.querySelectorAll('.auth-form__nav-button') as NodeListOf<HTMLButtonElement>,
      forms: section.querySelectorAll('.auth-form__form') as NodeListOf<HTMLFormElement>,
      steps: section.querySelectorAll('.auth-form__step') as NodeListOf<HTMLElement>,
      message: section.querySelector('.auth-form__message') as HTMLElement | null,
      inputs: section.querySelectorAll('.auth-form .input-group__input') as NodeListOf<HTMLInputElement>,
      challengeText: section.querySelector('.auth-form__challenge-text') as HTMLElement | null,
      header: section.querySelector('.auth-form__header') as HTMLElement | null,
      text: section.querySelector('.auth-form__text') as HTMLElement | null,
    }

    this.handleNav(el)
    this.formEvents(el)
    this.inputEvents(el)
  },
  handleSubmit(el: any, form: HTMLFormElement) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault()
      try {
        const antiforgeryToken = (form as any).__RequestVerificationToken.value
        const formData = new FormData(form)

        const data: any = {
          authType: formData.get('authType'),
          phoneOrSSN: formData.get('PhoneOrSSN'),
          culture: formData.get('culture'),
          type: formData.get('type'),
        }

        const request = await fetch('/umbraco/surface/auth/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            RequestVerificationToken: antiforgeryToken,
          },
          body: JSON.stringify(data),
        })

        if (!request.ok) {
          console.error('[auth-form | submit | !request.ok]')
          this.handleMessage(el, true, 'error')
          return
        }

        const res = await request.json()
        if (res.Error) {
          this.handleMessage(el, true, 'error')
          return
        }
        if (res.success) {
          this.poll(el, res, antiforgeryToken, data.type)
        } else {
          this.changeStep(el, 1)
          this.handleMessage(el, true, 'error')
        }
      } catch (error) {
        console.error('[auth-form | catch | error]', error)
      }
    })
  },
  async poll(el: any, request: any, antiforgeryToken: string, type: string) {
    this.changeStep(el, 2, request)

    const req = await fetch('/umbraco/surface/auth/verify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        RequestVerificationToken: antiforgeryToken,
      },
      body: JSON.stringify({
        culture: 'is-IS',
        authIdentifier: request.identifier,
      }),
    })

    if (!req.ok) {
      console.error('[auth-form | poll | !req.ok]')
      this.changeStep(el, 1)
      this.handleMessage(el, true, 'error')
      return
    }

    const response = await req.json()
    if (response.success) {
      if (type === 'register') {
        window.location.href = response.redirect
      } else {
        window.location.reload()
      }
    }
    if (response.error) {
      this.changeStep(el, 1)
      this.handleMessage(el, true, 'error')
      return
    }
  },
  handleMessage(el: any, show = false, type = 'error') {
    if (show && el.message) {
      el.message.style.display = 'block'

      setTimeout(() => {
        el.message.style.display = 'none'
      }, 5000)
    } else if (el.message) {
      el.message.style.display = 'none'
    }

    el.message?.classList.add(`message--${type}`)
  },
  changeStep(el: any, stepNumber: number, request: any = null) {
    el.steps.forEach((step: HTMLElement) => {
      step.style.display = 'none'
    })
    const chosenStep = el.root.querySelector(`.auth-form__step[data-step="${stepNumber}"]`) as HTMLElement | null
    if (chosenStep) {
      chosenStep.style.display = 'block'
    }

    if (stepNumber === 2 && el.challengeText && el.header && el.text) {
      el.challengeText.innerText = request.challenge
      el.header.classList.remove('auth-form__header--active')
      el.text.classList.remove('auth-form__text--active')
    }

    if (stepNumber === 1 && el.header && el.text) {
      el.header.classList.add('auth-form__header--active')
      el.text.classList.add('auth-form__text--active')
    }
  },
  handleNav(el: any) {
    el.navButtons.forEach((button: HTMLButtonElement) => {
      button.addEventListener('click', (e: Event & { target: HTMLButtonElement }) => {
        this.changeForm(el, e.target.dataset.method || '')
      })
    })
  },
  changeForm(el: any, method: string) {
    el.forms.forEach((item: HTMLElement) => {
      item.classList.remove('auth-form__form--active')
    })
    el.navButtons.forEach((button: HTMLElement) => {
      button.classList.remove('auth-form__nav-button--active')
    })
    el.root.querySelector(`.auth-form__form[data-method="${method}"]`)?.classList.add('auth-form__form--active')
    el.root
      .querySelector(`.auth-form__nav-button[data-method="${method}"]`)
      ?.classList.add('auth-form__nav-button--active')
  },
  formEvents(el: any) {
    el.forms.forEach((form: HTMLFormElement) => {
      this.handleSubmit(el, form)
    })
  },
  inputEvents(el: any) {
    el.inputs.forEach((input: HTMLInputElement) => {
      // This prevents ctrl + v
      input.onpaste = (e) => e.preventDefault()

      input.addEventListener('keyup', (e: Event & { target: HTMLInputElement; key: string }) => {
        if (e.key !== 'Backspace') {
          const regex = /^[0-9-]*$/

          if (!regex.test(e.target.value)) {
            // If the input doesn't match the pattern, clear the input value
            e.target.value = e.target.value.replace(/[^0-9-]/g, '')
          }

          if (e.target.dataset.mask === 'ssn' && e.target.value.length === 6) {
            e.target.value = `${e.target.value}-`
          }
          if (e.target.dataset.mask === 'tel' && e.target.value.length === 3) {
            e.target.value = `${e.target.value}-`
          }
        }

        const parent = e.target.closest<HTMLElement>('.auth-form__input-wrap')

        if (e.target.value.length >= e.target.maxLength) {
          parent?.querySelector<HTMLButtonElement>('.auth-form__submit')?.removeAttribute('disabled')
        } else {
          parent?.querySelector<HTMLButtonElement>('.auth-form__submit')?.setAttribute('disabled', '')
        }
      })
    })
  },
}

export default Auth
